import {CodeLabel} from 'public-shared/models/code-label/code-label.dto';
import {BaseNameDTO} from 'shared/services/base.dto';
import {J4Tenant, J4TenantAccountType, J4TenantCategory} from 'shared/services/j4-tenants/j4-tenant.dto';
import {WithMerchantName} from './with-merchant-name';

export class Merchant extends BaseNameDTO {
  public publicId?: string;
  public createdAt?: Date;
  public enabled?: boolean;
  public merchantId?: string;
  public tenantName?: string;
  public customerName?: string;
  public tenantGuid?: string;
  public merchantGuid?: string;
  public merchantInfoId?: string;
  public merchantName?: string;
  public wasMigrated?: boolean;
  public apiAccess?: boolean;
  public accountType?: J4TenantAccountType | null;
  public category?: J4TenantCategory | null;

  public static toRequestDto(merchant: Merchant, withEnabled = true): Merchant {
    const dto = new Merchant();
    if (withEnabled) {
      dto.enabled = merchant.enabled;
    }
    dto.name = merchant.name;
    return dto;
  }

  public static fromJ4Tenant(tenant: J4Tenant): Merchant {
    const merchant = new Merchant();
    merchant.id = tenant.customerId;
    merchant.merchantId = tenant.merchantId;
    merchant.name = tenant.name;
    merchant.customerName = tenant.customerName;
    merchant.publicId = tenant.id;
    merchant.merchantInfoId = tenant.merchantInfoId;
    merchant.merchantGuid = tenant.merchantGuid;
    merchant.merchantName = tenant.merchantName;
    merchant.enabled = tenant.status === 'ENABLED';
    merchant.apiAccess = tenant.apiAccess === 'ENABLED';
    merchant.accountType = tenant.accountType ?? null;
    merchant.category = tenant.category ?? null;
    //@ts-ignore
    merchant.createdAt = new Date(tenant.createdAt);
    return merchant;
  }
}

export class MerchantTypes {
  public types: CodeLabel[] | undefined;
}

export class MerchantDetail implements WithMerchantName {
  public merchantName: string | undefined;
  public merchantType: string | undefined;
  public contactName: string | undefined;
  public email: string | undefined;
}

export class AccountDuplicationPayload {
  public password: string | undefined;
  public passCode?: string;
  public reason?: string;
  public classification?: string;
  public stepUpToken?: string;
  public reauthenticationMethod?: 'PASSWORD' | 'OKTA_STEP_UP';
  public entity:
    | {
        merchantName: string;
        email: string;
        isTenant: boolean;
      }
    | undefined;
}
